import { ConstructorInCartModel, DishInCartModel } from 'domains/cart';
import { City, Country, Restaurant } from 'domains/cartography';
// import Cookies from 'js-cookie';
import { Address, OrderType } from 'models';

export type ProductsInCart = {
  dishes: DishInCartModel[];
  constructors: ConstructorInCartModel[];
};

const canUseLocalStorage = () => typeof localStorage !== 'undefined';

export class FELocalStorageUtil {
  static get showCookies() {
    if (!canUseLocalStorage()) return false;

    return !localStorage.getItem('cookiesPolicyAccepted');
  }
  static setShowCookies(show: boolean) {
    if (!canUseLocalStorage()) return;

    if (show) localStorage.removeItem('cookiesPolicyAccepted');
    else localStorage.setItem('cookiesPolicyAccepted', 'true');
  }

  static setCartography({
    type,
    address,
    restaurant,
    country,
    city,
  }: {
    type: OrderType;
    address: Address.ReceivingAddressV2 | null;
    restaurant: Restaurant | null;
    country: Country;
    city: City;
  }) {
    if (!canUseLocalStorage()) return;

    localStorage.setItem('type', type);

    const cookiesCity = JSON.stringify(city);
    localStorage.setItem('city', cookiesCity);

    const cookiesCountry = JSON.stringify(country);
    localStorage.setItem('country', cookiesCountry);

    if (address !== null) {
      localStorage.removeItem('restaurant');

      const cookiesAddress = JSON.stringify(address);
      localStorage.setItem('address', cookiesAddress);
    } else {
      localStorage.removeItem('address');

      if (restaurant !== null) {
        const cookiesRestaurant = JSON.stringify(restaurant);
        localStorage.setItem('restaurant', cookiesRestaurant);
      }
    }
  }

  static get getCartography(): {
    type: OrderType | null;
    address: Address.ReceivingAddressV2 | null;
    restaurant: Restaurant | null;
    country: Country | null;
    city: City | null;
  } {
    if (!canUseLocalStorage()) {
      return {
        city: null,
        country: null,
        type: null,
        address: null,
        restaurant: null,
      };
    }

    const cookiesAddress = localStorage.getItem('address');
    const cookiesRestaurant = localStorage.getItem('restaurant');
    const cookiesCity = localStorage.getItem('city');
    const cookiesCountry = localStorage.getItem('country');

    const type = (localStorage.getItem('type') as OrderType | null) || null;
    const address: Address.ReceivingAddressV2 | null = cookiesAddress
      ? JSON.parse(cookiesAddress)
      : null;
    const restaurant: Restaurant | null = cookiesRestaurant
      ? JSON.parse(cookiesRestaurant)
      : null;
    const city: City | null = cookiesCity ? JSON.parse(cookiesCity) : null;
    const country: Country | null = cookiesCountry
      ? JSON.parse(cookiesCountry)
      : null;

    return {
      city,
      country,
      type,
      address,
      restaurant,
    };
  }

  static deleteLastOrder() {
    if (!canUseLocalStorage()) return;

    // Cookies.remove('lastOrderId');
    localStorage.removeItem('lastOrderId');
  }
  static setLastOrderId({ lastOrderId }: { lastOrderId: string }) {
    if (!canUseLocalStorage()) return;

    localStorage.setItem('lastOrderId', lastOrderId);
    // Cookies.set('lastOrderId', lastOrderId);
  }
  static get getLastOrderId() {
    if (!canUseLocalStorage()) return { lastOrderId: null };

    return { lastOrderId: localStorage.getItem('lastOrderId') || null };
    // return { lastOrderId: Cookies.get('lastOrderId') || null };
  }

  static setCartData(products: ProductsInCart) {
    if (!canUseLocalStorage()) return;

    localStorage.setItem('cartData', JSON.stringify(products));
  }
  static get getCartData(): ProductsInCart | null {
    if (!canUseLocalStorage()) return null;

    const localStorageProducts = localStorage.getItem('cartData');

    const cartData: ProductsInCart | null = localStorageProducts
      ? (JSON.parse(localStorageProducts) as ProductsInCart)
      : null;

    return cartData;
  }
  static clearCartData() {
    if (!canUseLocalStorage()) return;

    localStorage.removeItem('cartData');
  }
}
